import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { SignoCentroMedico } from 'src/app/interfaces/interface-bakend/entidades/signo-centro-medico.interface';
import { SignoCentroMedicoService } from 'src/app/services/entidades/signo-centros-medicos.service';
import { SignoLocalidad } from 'src/app/interfaces/interface-bakend/entidades/signo-localidad.interface';
import { SignoLocalidadService } from 'src/app/services/entidades/signo-localidades.service';
import { Catalogo } from 'src/app/interfaces/interface-bakend/shared/catalogo/catalogo.interface';
import { CatalogoService } from 'src/app/services/shared/catalogo.service';
import { GuiMsjService } from 'src/app/services/shared/gui-msj.service';
import { PerfilesService } from '@services/perfiles/perfiles.service';
import { AuthService } from '@services/auth/auth.service';
import { SignoPlan } from '@interfaces/interface-bakend/entidades/signo-plan.interface';
import Swal from 'sweetalert2';
import { SignoPlanService } from '@services/entidades/signo-planes.service';
import { EntidadesKeys } from '@enum/entidades-keys.enum';
import { MatSelectChange } from '@angular/material/select';

@Component({
  selector: 'app-centros-medicos-listado',
  templateUrl: './centros-medicos-listado.component.html',
  styleUrls: ['./centros-medicos-listado.component.scss']
})
export class CentrosMedicosListadoComponent implements OnInit {
  @ViewChild('previousRoute') previousRouteLink: ElementRef;

  /* Data Table*/
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('input') input: ElementRef;
  displayedColumns: string[] = [
    'nombre',
    'direccion',
    'zona',
    'localidad',
    // 'horarios',
    'planes',
    'geo',
    'activo',
    '_id',
  ];

  dataSource: MatTableDataSource<SignoCentroMedico>;
  /* Fin Data Table*/

  // Flags de estado
  flagLoaded: boolean = false;
  dataLoaded: boolean = false;
  
  // Spinner
  showSpinner: boolean = false;
  spinnerText: string = 'Cargando centros médicos...';
  
  // Geolocalización filter
  filtroSinGeo: boolean = false;
  contadorSinGeo: number = 0;
  private dataSinFiltroGeo: any[] = [];
  buscando: boolean = false;

  // Tracking Geolocalización
  isGeolocating: boolean = false;
  geoInitialCount: number = 0;
  geoCurrentCount: number = 0;
  geoProgress: number = 0;
  private geoInterval: any;
  
  // Filtros para los mat-select
  planesSeleccionadosIds: (string | null)[] = [];
  rubroSeleccionadoId: string | null = null;
  especialidadSeleccionadaId: string | null = null;
  filtroTexto: string = '';
  
  // Datos para los filtros
  planesFiltros: SignoPlan[] = [];
  rubros: Catalogo[] = [];
  especialidadesCompletas: Catalogo[] = [];
  especialidadesFiltradas: Catalogo[] = [];
  
  // Variables para tracking
  keyPerfil: string = '';
  mensajeFiltros: string = '';
  
  // Mantener compatibilidad con lógica existente
  hasData = (index: number, row: SignoCentroMedico) => !!row;
  noDataFilter = () => this.dataSource.data.length === 0;
  
  private filtroCombinado = {
    texto: '',
    planes: [] as string[],
    especialidades: [] as string[],
    rubros: [] as string[],
    sinGeo: false
  };

  constructor(
    private router: Router,
    private signoCentroMedicoService: SignoCentroMedicoService,
    private signoLocalidadService: SignoLocalidadService,
    private signoPlanService: SignoPlanService,
    private catalogoService: CatalogoService,
    private guiMsjService: GuiMsjService,
    private authService: AuthService,
    private perfilesService: PerfilesService,
  ) {
    console.log('🔄 CentrosMedicosListadoComponent - Constructor inicializado');
    this.dataSource = new MatTableDataSource();
  }

  ngOnInit(): void {
    this.showSpinner = true;
    this.spinnerText = 'Cargando…';
    this.getPerfil().then(() => {
      this.perfilesService.allowedByUserLogon(this.router.url, this.previousRoute, this.keyPerfil);
    });
    this.loadDataFiltros();
  }

  async ngAfterViewInit() {
    console.log('🔄 ngAfterViewInit - Configurando tabla');
    // Solo configuramos la tabla, no cargamos datos
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.setFilterPredicate();
    this.configurarDataSource();
  }

  get previousRoute() {
    const previousRoute = this.previousRouteLink.nativeElement.getAttribute('href');
    console.log(`🔗 Ruta anterior: ${previousRoute}`);
    return previousRoute;
  }

  async getPerfil() {
    try {
      console.log('👤 Obteniendo perfil del usuario');
      const user = await this.authService.getUserLogon();
      if (user) {
        const { key } = user?.perfil;
        this.keyPerfil = key;
        console.log(`✅ Perfil obtenido: ${key}`);
      }
    }
    catch (error) {
      console.error('❌ Error al obtener el perfil del usuario', error);
      return '';
    }
  }

  async loadDataFiltros() {
    console.log('🔄 loadDataFiltros - Cargando datos para filtros');
    try {
      const [
        todosLosPlanes, 
        especialidades,
        rubros
      ] = await Promise.all([
        this.signoPlanService.getPlanes(),
        this.catalogoService.findDescendantsByKey(EntidadesKeys.ESPECIALIDADES),
        this.catalogoService.findDescendantsByKey(EntidadesKeys.RUBROS)
      ]);

      console.log(`📊 Datos cargados: ${todosLosPlanes.length} planes, ${especialidades.length} especialidades, ${rubros.length} rubros`);

      this.planesFiltros = todosLosPlanes;
      this.rubros = rubros;
      this.especialidadesCompletas = [...especialidades];
      
      this.flagLoaded = true;
      console.log('✅ Filtros cargados correctamente');
      
    } catch (error) {
      console.error("❌ Error al cargar los filtros", error);
      this.flagLoaded = true;
    } finally {
      this.showSpinner = false;
    }
  }

  async loadCentrosMedicos() {
    console.log('📥 Cargando centros médicos desde servicio...');
    this.buscando = true;
    this.showSpinner = true;
    this.spinnerText = 'Cargando centros médicos...';
    
    try {
      const signoCentrosMedicos = await this.signoCentroMedicoService.getCentroMedicos();
      console.log(`📥 Centros médicos cargados: ${signoCentrosMedicos.length}`);
      
      const todosLosPlanes = await this.signoPlanService.getPlanes();
      
      const centrosMedicosConNombresDePlanes = signoCentrosMedicos.map(centro => {
        const planesConDenominacion = (centro.planes || []).map(planItem => {
          const planId = (typeof planItem === 'string') ? planItem : planItem._id;
          const planEncontrado = todosLosPlanes.find(p => p._id === planId);
          return planEncontrado ? planEncontrado.denominacion.replace(/plan\s*/i, '').trim() : 'Desconocido';
        });
        return {
          ...centro,
          planesDenominacion: planesConDenominacion.join(', ')
        };
      });

      this.dataSource = new MatTableDataSource(centrosMedicosConNombresDePlanes);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
      this.setFilterPredicate(); // Re-aplicar filterPredicate al nuevo dataSource
      this.configurarDataSource();
      
      this.dataLoaded = true;
      this.actualizarContadorSinGeo(); // Calcular contador inicial
      this.mensajeFiltros = `Se cargaron ${signoCentrosMedicos.length} centros médicos`;
      console.log('✅ Centros médicos cargados en la tabla');
      
    } catch (error) {
      console.error('❌ Error al cargar centros médicos:', error);
      this.mensajeFiltros = 'Error al cargar centros médicos';
      this.dataLoaded = false;
    } finally {
      this.buscando = false;
      this.showSpinner = false;
    }
  }

  onPlanesChange(event: MatSelectChange) {
    console.log('🔄 onPlanesChange - Evento:', event.value);
    
    // Si viene null (porque se seleccionó NINGUNO), queremos filtrar por centros que NO tengan planes
    // En MatSelect multiple, si seleccionan NINGUNO, event.value tendrá [null]
    if (event.value.includes(null)) {
      if (event.value.length > 1) {
        // Si seleccionó NINGUNO y otros planes, forzamos solo NINGUNO o limpiamos dependiendo de la UX deseada
        // Aquí optamos por mantener solo lo que no es null si hay otros, o solo null si es el único
        this.planesSeleccionadosIds = event.value.filter((id: any) => id !== null);
      } else {
        this.planesSeleccionadosIds = [null];
      }
    } else {
      this.planesSeleccionadosIds = event.value;
    }
    
    console.log(`📝 Planes seleccionados: ${JSON.stringify(this.planesSeleccionadosIds)}`);
  }

  onRubroChange(event: MatSelectChange) {
    console.log(`🔄 onRubroChange - Rubro seleccionado: ${event.value}`);
    this.rubroSeleccionadoId = event.value === 'null' ? null : event.value;
    this.especialidadSeleccionadaId = null; // Resetear especialidad al cambiar rubro
    
    if (this.rubroSeleccionadoId) {
      this.especialidadesFiltradas = this.especialidadesCompletas.filter(esp => 
        (esp.properties as any)?.rubro === this.rubroSeleccionadoId
      );
      console.log(`📋 Especialidades filtradas: ${this.especialidadesFiltradas.length} para rubro ${this.rubroSeleccionadoId}`);
    } else {
      this.especialidadesFiltradas = [];
      console.log('📋 Especialidades filtradas: vacío (sin rubro)');
    }
  }

  async aplicarFiltrosCombinados() {
    console.log('🔍 aplicarFiltrosCombinados - Iniciando búsqueda');
    this.buscando = true;
    this.showSpinner = true;
    this.spinnerText = 'Buscando centros médicos...';
    
    try {
      console.log(`📝 Filtros aplicados: 
      - Planes: ${JSON.stringify(this.planesSeleccionadosIds)}
      - Rubro: ${this.rubroSeleccionadoId}
      - Especialidad: ${this.especialidadSeleccionadaId}`);
    
      this.mensajeFiltros = 'Aplicando filtros...';
      
      // Si no hay datos cargados, cargamos todos los centros médicos
      if (!this.dataLoaded) {
        console.log('📥 No hay datos cargados, cargando centros médicos...');
        await this.loadCentrosMedicos();
      }
      
      // Preparar filtro actual
      const planesFiltro = this.planesSeleccionadosIds
        .filter(id => id !== null) as string[];
      
      const incluyeNingunPlan = this.planesSeleccionadosIds.includes(null);
      
      const especialidadesFiltro = this.especialidadSeleccionadaId 
        ? [this.especialidadSeleccionadaId] 
        : [];
      
      const rubrosFiltro = this.rubroSeleccionadoId 
        ? [this.rubroSeleccionadoId] 
        : [];

      this.filtroCombinado = {
        texto: this.filtroTexto.toLowerCase(),
        planes: this.planesSeleccionadosIds, // Incluye null si se seleccionó NINGUNO
        especialidades: especialidadesFiltro,
        rubros: rubrosFiltro,
        sinGeo: this.filtroSinGeo
      };

      console.log(`🎯 Aplicando filtro combinado:`, this.filtroCombinado);
      
      // Aplicar el filtro mediante el predicate del MatTableDataSource
      this.dataSource.filter = JSON.stringify(this.filtroCombinado);
      this.dataSource.paginator?.firstPage();
      
      // Actualizar mensaje de resultados
      const resultados = this.dataSource.filteredData.length;
      
      this.actualizarContadorSinGeo();
      
      if (this.filtroCombinado.texto === '' && 
          this.filtroCombinado.planes.length === 0 && 
          !incluyeNingunPlan &&
          this.filtroCombinado.especialidades.length === 0 && 
          this.filtroCombinado.rubros.length === 0 &&
          !this.filtroCombinado.sinGeo) {
        this.mensajeFiltros = `Mostrando todos los centros médicos (${resultados})`;
      } else {
        this.mensajeFiltros = `Encontrados ${resultados} centro(s) médico(s)`;
      }
      console.log(`✅ Filtros aplicados: ${resultados} resultados`);
      
    } catch (error) {
      console.error('❌ Error en aplicarFiltrosCombinados:', error);
      this.mensajeFiltros = 'Error al buscar centros médicos';
    } finally {
      this.buscando = false;
      this.showSpinner = false;
    }
  }

  limpiarFiltrosCombinados() {
    console.log('🧹 limpiarFiltrosCombinados - Limpiando filtros combinados');
    
    // Resetear solo los filtros combinados, no el texto
    this.planesSeleccionadosIds = [];
    this.rubroSeleccionadoId = null;
    this.especialidadSeleccionadaId = null;
    this.especialidadesFiltradas = [];
    this.filtroSinGeo = false; 
    
    // Resetear filtro combinado
    this.filtroCombinado = {
      texto: this.filtroTexto.toLowerCase(), // Mantener el texto si hay
      planes: [],
      especialidades: [],
      rubros: [],
      sinGeo: false
    };
    
    // Aplicar filtro (que ahora solo tiene el texto si existe) - solo si hay datos cargados
    if (this.dataLoaded) {
      if (this.filtroTexto) {
        this.dataSource.filter = JSON.stringify(this.filtroCombinado);
      } else {
        this.dataSource.filter = '';
      }
      this.dataSource.paginator?.firstPage();
    }
    
    this.mensajeFiltros = '';
    console.log('✅ Filtros combinados limpiados');
  }

  // Filtro de texto en tiempo real
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.filtroTexto = filterValue.trim().toLowerCase();
    
    // Actualizar el filtro combinado con el texto
    this.filtroCombinado.texto = this.filtroTexto;
    
    // Aplicar el filtro solo si ya hay datos cargados
    if (this.dataLoaded) {
      // Si hay texto o algún otro filtro activo, aplicar filtro
      if (this.filtroTexto || 
          this.filtroCombinado.planes.length > 0 || 
          this.filtroCombinado.especialidades.length > 0 || 
          this.filtroCombinado.rubros.length > 0) {
        this.dataSource.filter = JSON.stringify(this.filtroCombinado);
      } else {
        // Si no hay ningún filtro, mostrar todo
        this.dataSource.filter = '';
      }
      this.dataSource.paginator?.firstPage();
    }
    
    console.log(`🔍 Filtro de texto aplicado: "${filterValue}"`);
  }

  // --- GEOLOCALIZACIÓN FILTER ---

  tieneGeolocalizacion(element: SignoCentroMedico): boolean {
    return element.latitud != null && element.longitud != null &&
           element.latitud !== 0 && element.longitud !== 0;
  }

  actualizarContadorSinGeo() {
    if (this.dataSource && this.dataSource.data) {
      // Calculamos sobre el dataset total para que el botón siempre muestre el total de pendientes
      this.contadorSinGeo = this.dataSource.data.filter(c => !this.tieneGeolocalizacion(c)).length;
      console.log(`📊 Contador Sin Geo actualizado: ${this.contadorSinGeo}`);
    }
  }

  filtrarSinGeolocalizacion() {
    if (!this.dataLoaded) {
      this.loadCentrosMedicos().then(() => {
        this.toggleFiltroGeo();
      });
    } else {
      this.toggleFiltroGeo();
    }
  }

  private toggleFiltroGeo() {
    this.filtroSinGeo = !this.filtroSinGeo;
    this.aplicarFiltrosCombinados();
  }

  limpiarFiltroGeo() {
    this.filtroSinGeo = false;
    this.aplicarFiltrosCombinados();
  }

  async geolocalizarPendientes() {
    if (this.isGeolocating) return;

    // 1. Identificar centros sin coordenadas
    const data = await this.signoCentroMedicoService.getCentroMedicos();
    const pendingCentros = data.filter(c => !c.latitud || c.latitud === 0);
    
    this.geoInitialCount = pendingCentros.length;
    this.geoCurrentCount = this.geoInitialCount;

    if (this.geoInitialCount === 0) {
      Swal.fire('Info', 'No hay centros pendientes de geolocalización', 'info');
      return;
    }

    const swalInstance = Swal.fire({
      title: 'Geolocalizando Centros',
      html: `
        <div id="swal-geo-content">Iniciando proceso... <br> <b>0%</b> completado</div>
        <div id="swal-geo-current" class="mt-2 text-primary small font-weight-bold" style="min-height: 20px;"></div>
        <div id="swal-geo-status" class="small" style="min-height: 20px;"></div>
        <div class="mt-3 p-2 bg-light border rounded small text-muted">
          <i class="fas fa-info-circle text-info"></i> El proceso respeta los límites de velocidad de los mapas (Nominatim).<br><b>No cierre esta pestaña</b> hasta finalizar.
        </div>
        <div class="mt-3 spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
          <span class="sr-only">Loading...</span>
        </div>
      `,
      allowOutsideClick: false,
// ... (omitting middle lines for now, but will use a better replacement chunk)
      showConfirmButton: false,
      showCancelButton: true,
      cancelButtonText: 'Interrumpir Proceso',
      cancelButtonColor: '#d33',
    });

    this.isGeolocating = true;

    // Manejar la cancelación por el usuario
    let cancelProcessing = false;
    swalInstance.then((result) => {
      if (result.dismiss === Swal.DismissReason.cancel) {
        cancelProcessing = true;
        this.isGeolocating = false;
        Swal.fire({
          title: 'Proceso Interrumpido',
          text: "Se ha detenido el proceso de geolocalización.",
          icon: 'warning',
          confirmButtonText: 'Entendido'
        });
      }
    });

    let geolocalizados = 0;
    let fallidos = 0;

    try {
      for (let i = 0; i < pendingCentros.length; i++) {
        if (cancelProcessing) break;
        
        const centro = pendingCentros[i];
        
        // Actualizar UI Progress
        const progress = Math.round((i / this.geoInitialCount) * 100);
        const content = document.getElementById('swal-geo-content');
        const currentLabel = document.getElementById('swal-geo-current');
        
        if (content) content.innerHTML = `Procesando centros... <br> <b>${progress}%</b> (${i}/${this.geoInitialCount})`;
        if (currentLabel) currentLabel.innerText = `Actual: ${centro.nombre}`;
        const statusLabel = document.getElementById('swal-geo-status');
        if (statusLabel) statusLabel.innerHTML = '<span class="text-muted small">Procesando...</span>';

        // Llamada individual al backend con reintentos para Rate Limit
        let retryCount = 0;
        let success = false;
        
        while (retryCount < 2 && !success && !cancelProcessing) {
          try {
            const res = await this.signoCentroMedicoService.geolocateOne(centro._id);
            if (res && res.success) {
              geolocalizados++;
              success = true;
              if (statusLabel) statusLabel.innerHTML = '<i class="fas fa-check-circle text-success pulse"></i> <span class="text-success font-weight-bold">¡Geolocalizado con éxito!</span>';
            } else {
              // Error de dirección u otro (no 429)
              fallidos++;
              success = true; 
              if (statusLabel) statusLabel.innerHTML = '<i class="fas fa-exclamation-triangle text-danger"></i> <span class="text-danger">No se pudo geolocalizar (verifique dirección)</span>';
            }
          } catch (err) {
            if (err.status === 429) {
              retryCount++;
              if (retryCount < 2) {
                if (statusLabel) statusLabel.innerHTML = `<i class="fas fa-clock text-warning"></i> <span class="text-danger">Límite alcanzado. Reintentando en 10s...</span>`;
                await new Promise(resolve => setTimeout(resolve, 10000));
              } else {
                fallidos++;
                success = true; 
                if (statusLabel) statusLabel.innerHTML = '<i class="fas fa-times-circle text-danger"></i> <span class="text-danger">Error: Límite de intentos agotado.</span>';
              }
            } else {
              // Otro error HTTP no recuperable
              fallidos++;
              success = true;
              if (statusLabel) statusLabel.innerHTML = '<i class="fas fa-bug text-danger"></i> <span class="text-danger">Error inesperado en este registro.</span>';
              console.error('Error HTTP no recuperable:', err);
            }
          }
        }

        // Pequeño delay adicional para asegurar actualización visual y respetar rate limit
        if (i < pendingCentros.length - 1) {
           await new Promise(resolve => setTimeout(resolve, 2000));
        }
      }

      if (!cancelProcessing) {
        // Refresco final
        await this.loadCentrosMedicos();
        
        let finalIcon: 'success' | 'warning' = fallidos > 0 ? 'warning' : 'success';
        let finalTitle = fallidos > 0 ? 'Proceso Finalizado' : '¡Éxito!';
        let finalMsg = fallidos > 0 
          ? `Se geolocalizaron <b>${geolocalizados}</b> centros. <b>${fallidos}</b> no pudieron ser ubicados (verifique direcciones).`
          : `Se geolocalizaron <b>${geolocalizados}</b> centros correctamente.`;

        Swal.fire({
          title: finalTitle,
          icon: finalIcon,
          html: `<div class="text-center">${finalMsg}</div>`,
          confirmButtonText: 'Entendido'
        });
      }

    } catch (error) {
      console.error('Error en geolocalización secuencial:', error);
      if (!cancelProcessing) {
        Swal.fire('Error', 'Ocurrió un error inesperado durante el proceso.', 'error');
      }
    } finally {
      this.isGeolocating = false;
    }
  }

  private procesarPlanes(signoCentrosMedicos: SignoCentroMedico[]): any[] {
    // Reutilizar lógica de loadCentrosMedicos para procesar nombres de planes
    // (Nota: se podría desacoplar para evitar redundancia)
    return signoCentrosMedicos.map(centro => {
      return {
        ...centro,
        planesDenominacion: (centro.planes || []).map(p => {
          const denom = typeof p === 'object' ? p.denominacion : 'Desconocido';
          return denom.replace(/plan\s*/i, '').trim();
        }).join(', ')
      };
    });
  }

  // MÉTODOS EXISTENTES (mantenidos para compatibilidad)

  async getZonaConcepto(_id: string): Promise<Catalogo> {
    try {
      const zona = await this.catalogoService.getFindOne(_id);
      if (zona) {
        return zona;
      } else {
        console.error("Zona no encontrada");
        return undefined;
      }
    } catch (error) {
      console.error(error, "Error al obtener la zona");
      return undefined;
    }
  }

  async getLocalidadNombre(_id: string): Promise<SignoLocalidad> {
    try {
      const localidad = await this.signoLocalidadService.getLocalidadById(_id);
      if (localidad) {
        return localidad;
      } else {
        console.error("Localidad no encontrada");
        return undefined;
      }
    } catch (error) {
      console.error(error, "Error al obtener la localidad");
      return undefined;
    }
  }

  async verCentroMedico(_id: string) {
    console.log(`👁️ Ver centro médico con ID: ${_id}`);
    
    await this.guiMsjService.msjFormSubmit('Espere');
    Swal.showLoading();
    const centroMedico: SignoCentroMedico = await this.signoCentroMedicoService.getCentroMedicoById(_id);
    if (centroMedico != undefined) {
      this.router.navigateByUrl('/centro-medico-modificacion');
      this.signoCentroMedicoService.setCentroMedicoSeleccionado(centroMedico);
      Swal.close();
      console.log('✅ Navegando a modificación');
    }
    else {
      Swal.close();
      console.error('❌ Centro médico no encontrado');
    }
  }

  configurarDataSource() {
    this.dataSource.sortingDataAccessor = (item: SignoCentroMedico, property: string) => {
      switch (property) {
        case 'direccion': return `${item.calle || ''} ${item.altura || ''}`.trim().toLowerCase();
        case 'zona': return item.zona?.concepto?.toLowerCase() || '';
        case 'localidad': return item.localidad?.nombre?.toLowerCase() || '';
        case 'planes': return ((item as any).planesDenominacion?.toLowerCase() || '');
        case 'geo': return this.tieneGeolocalizacion(item) ? '1' : '0';
        default: return ((item as any)[property] ?? '').toString().toLowerCase();
      }
    };
  }

  private normalizarFuzzy(texto: string): string {
    return (texto || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  }

  private contiene(query: string, texto: string): boolean {
    const q = this.normalizarFuzzy(query);
    if (!q) return true;
    return this.normalizarFuzzy(texto).includes(q);
  }

  setFilterPredicate() {
    console.log('⚙️ Configurando filterPredicate consolidado');
    this.dataSource.filterPredicate = (data: SignoCentroMedico, filter: string): boolean => {
      // Si el filtro está vacío, mostrar todo
      if (!filter || filter === '') {
        return true;
      }

      const filtro = JSON.parse(filter);
      const searchText = filtro.texto.toLowerCase();

      // 1. Filtro de texto (substring sin tildes sobre campos útiles)
      const cumpleTexto = !searchText || (
        this.contiene(searchText, data.nombre || '') ||
        this.contiene(searchText, `${data.calle || ''} ${data.altura || ''}`.trim()) ||
        this.contiene(searchText, data.zona?.concepto || '') ||
        this.contiene(searchText, data.localidad?.nombre || '')
      );

      // 2. Filtro por planes
      const cumplePlanes = filtro.planes.length === 0 || 
        (data.planes || []).some(planItem => {
          const planId = typeof planItem === 'string' ? planItem : planItem._id;
          return filtro.planes.includes(planId);
        }) || (filtro.planes.includes(null) && (!data.planes || data.planes.length === 0));

      // 3. Filtro por especialidades
      const cumpleEspecialidades = filtro.especialidades.length === 0 || 
        (data.especialidades || []).some(espItem => {
          const espId = typeof espItem === 'string' ? espItem : espItem._id;
          return filtro.especialidades.includes(espId);
        });

      // 4. Filtro por rubros
      const cumpleRubros = filtro.rubros.length === 0 || 
        (data.rubros || []).some(rubroItem => {
          const rubroId = typeof rubroItem === 'string' ? rubroItem : rubroItem._id;
          return filtro.rubros.includes(rubroId);
        });

      // 5. Filtro por geolocalización
      const cumpleGeo = !filtro.sinGeo || !this.tieneGeolocalizacion(data);

      return cumpleTexto && cumplePlanes && cumpleEspecialidades && cumpleRubros && cumpleGeo;
    };
  }

  async toggleActivo(element: SignoCentroMedico, event: Event) {
    console.log(`🔄 toggleActivo - Cambiando estado de centro ${element.nombre}`);
    
    const isChecked = (event.target as HTMLInputElement).checked;
    const originalValue = element.activo;
    
    try {
        await this.guiMsjService.msjFormSubmit('Guardando');
        
        const centroActual = await this.signoCentroMedicoService.getCentroMedicoById(element._id);
        
        const updateData: SignoCentroMedico = {
            ...centroActual,
            activo: isChecked,
            // Campos requeridos con valores por defecto
            horarios: centroActual.horarios || '',
            celular: centroActual.celular || '',
            pisoDpto: centroActual.pisoDpto || '',
            // Transformación de relaciones según interfaz
            zona: this.parseZona(centroActual.zona),
            localidad: await this.parseLocalidad(centroActual.localidad),
            rubros: this.parseCatalogos(centroActual.rubros),
            especialidades: this.parseCatalogos(centroActual.especialidades),
            planes: this.parsePlanes(centroActual.planes)
        };

        await this.signoCentroMedicoService.updateCentroMedico(element._id, updateData);
        
        element.activo = isChecked;
        this.dataSource.data = [...this.dataSource.data];
        await this.guiMsjService.msjFormSubmit('DatosGuardados');
        
        console.log(`✅ Estado actualizado: ${element.nombre} -> ${isChecked ? 'Activo' : 'Inactivo'}`);

    } catch (error) {
        console.error('❌ Error al actualizar:', error);
        (event.target as HTMLInputElement).checked = originalValue;
        element.activo = originalValue;
        await this.guiMsjService.msjFormSubmit('ErrorGuardandoDatos');
    }
  }

  // Funciones de transformación esenciales
  private parseZona(zona: Catalogo | string): Catalogo {
    return typeof zona === 'string' 
      ? { _id: zona, concepto: '' } 
      : { _id: zona._id, concepto: zona.concepto || '' };
  }

  private async parseLocalidad(localidad: SignoLocalidad | string): Promise<SignoLocalidad> {
    if (typeof localidad === 'string') {
      const l = await this.signoLocalidadService.getLocalidadById(localidad);
      return { _id: l._id, nombre: l.nombre, activo: l.activo, zona: this.parseZona(l.zona) };
    }
    return { 
      _id: localidad._id, 
      nombre: localidad.nombre, 
      activo: localidad.activo, 
      zona: this.parseZona(localidad.zona) 
    };
  }

  private parseCatalogos(items: (Catalogo | string)[]): Catalogo[] {
    return items.map(item => ({
      _id: typeof item === 'string' ? item : item._id,
      concepto: typeof item === 'string' ? '' : item.concepto || ''
    }));
  }

  private parsePlanes(planes: (SignoPlan | string)[]): SignoPlan[] {
    return planes.map(plan => ({
      _id: typeof plan === 'string' ? plan : plan._id,
      denominacion: typeof plan === 'string' ? '' : plan.denominacion || ''
    }));
  }
}